import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

const SignUp = () => {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    mobile: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [inviteToken, setInviteToken] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("inviteToken");
    if (token) {
      setInviteToken(token);
    }
  }, [location]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow digits, spaces, dashes, parentheses, and a leading + for mobile input
    if (name === "mobile" && !/^[\d\s\-()+]*$/.test(value)) return;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Basic sanity check — just make sure there are enough digits.
    // Final normalization happens on the backend.
    const digitCount = formData.mobile.replace(/[^\d]/g, '').length;
    if (digitCount < 9 || digitCount > 15) {
      setError("Please enter a valid mobile number, including your country code if outside South Africa.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const { confirmPassword, ...dataToSend } = formData;
      const payload = { ...dataToSend };

      if (inviteToken) {
        payload.inviteToken = inviteToken;
      }

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/signup`,
        payload
      );

      alert("Sign up successful!");
      navigate("/login");
    } catch (err) {
      console.error(err);
      const message = err.response?.data?.message || "An unexpected error occurred.";
      setError(message);
    }
  };

  return (
    <div className="signup-form">
      <h2>Sign Up</h2>
      {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          className="input-narrow"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          className="input-narrow"
          name="surname"
          placeholder="Surname"
          value={formData.surname}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          className="input-narrow"
          name="mobile"
          placeholder="Mobile e.g. 082 123 4567 or +44 7911 123456"
          value={formData.mobile}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          className="input-narrow"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          className="input-narrow"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          className="input-narrow"
          name="confirmPassword"
          placeholder="Confirm Password"
          value={formData.confirmPassword}
          onChange={handleChange}
          required
        />
        <div className="button-group">
          <button type="submit">Sign Up</button>
        </div>
      </form>
    </div>
  );
};

export default SignUp;
